const constants = {
  THEMING_UI: 'themingUI',
  CREATE_SHOW: 'createShow',
  AI_NAVIGATION: 'aiNavigation',
  AI_GROUNDING: 'aiGrounding',
  ONE_DEMAND: 'onDemandProduct',
};

export default constants;
